import lang from "element-ui/lib/locale/lang/en"; // 引入element语言包
const messages = {
  "极兔开放平台": "J & T  OPEN PLATFORM",
  帮助中心:"HELP",
  '注 册': "Register",
  indexPage:{
    title:"Courier services docking technology platform",
    BannerTxt:"Sharing various service interfaces of J&T, realizing the integration of logistics supply chain, helping enterprises to efficiently complete express delivery, information tracking, and providing value-added services of express information security. Realize efficient cooperation with J&T.",
    BannerBtnTxt:"Join J & T open platform",
  },
  helpCenter:{
    "常用工具":"Common Tools",
    签名工具: "Signature tool",
    电子面单模板: "Electronic face sheet template",
    "API-SDK说明": "API-SDK description",
    签名方式:"Signature method",
    method_1:"1. Use the http protocol form submission method for information interaction, the character encoding is unified by UTF-8 by default, and the data format: application/x-www-form-urlencoded;",
    method_2:"2. apiAccount and privateKey are provided by the platform; digest=base64(md5 (Json+privateKey of business parameters)), note: first md5 gets the byte array, and then base64 encryption;",
    method_3:`3. For example: base64(MD5({"age":18,"gender":"male","name":"zhangsan"}123456)) If the signature is wrong, you can encode the URL and send the request.`,
    method_4:"4. Field type convention: development should be carried out in strict accordance with the parameter format and size given in the field table.",
    method_5:"5. Field resolution conventions: the required fields in the parameter fields are required to be passed in every time the interface is called;",
    method_6:"6. For part of the interface sample code and SDK, please refer to the sample code and SDK documentation.",
    业务参数签名:"Business parameter signature",
    请输入加密后的32位pwd:"Please input the 32-bit encrypted pwd",
    获取:"Get",
    Headers签名:"Headers signature",
    bussness:"Example: When calling the interface of placing an order, canceling an order, etc., the business parameter <code>digest</code> is required, and the business parameter <code>digest</code> has a different meaning from the <code>digest</code> in the global Headers.",

    bussness_1:`First of all, Jitu will assign an account and password required by the agreement customer to place an order. For example: <code>J0086474299</code>/<code>H5CD3zE6</code>, where <code>pwd</code> is equal to <code>MD5 (plain text password (H5CD3zE6)+jadada236t2)</code>
    After capitalization, for example, the 32-bit <code>pwd</code> generated by this example is <code>6A272C3DD1F3CD2F92BF567C37040910</code>, and finally the business parameter signature is generated according to the rule Base64 (Md5 (customer number + cipher text + privateKey)).`,
    bussness_2:`That is: business parameter signature <code>digest</code>=Base64(Md5(<code>J0086474299</code>+<code>6A272C3DD1F3CD2F92BF567C37040910</code>+privateKey))`,
    headers_1:`Example: Take cancellation of an order as an example: suppose the business parameter is bizContent as <code>{"customerCode": "J0086474299","digest": "U40e5sumorgd3YgZzU","txlogisticId": "10000000001299","reason": "YL1234567890123"} </code>, then the signature digest in the header at this time is equal to <code>base64(md5(Json+privateKey of business parameters))</code>,`,
    headers_2:`That is <code>base64(md5({"customerCode": "J0086474299","digest": "U40e5sumorgd3YgZzU", "txlogisticId":"10000000001299","reason": "YL1234567890123"}+privateKey))</code>.`,
    headers_3:`Note: <code>privateKey</code> is automatically assigned after the account is authenticated by the platform`,
    一联模版:"One-page template",
    "API开放平台-SDK":"Open API platform -SDK",
    "Introduction":"1.Introduction",
    "sdk_two":"2. Version update record",
    "sdk_3_title":"3. Quick Start Install API Open Platform SDK",
    "sdk_4_title":"4. API-SDK directory structure",
    "sdk_5_title":"5. JAR package directly following steps:",
    "sdk_6_title":"6. SDK related maven dependencies",
    "sdk_7_title":"7. Create JtExpressApi",
    "sdk_8_title":"8. Suggestion",
    "Introduction_1":"Hi, hello, and welcome to use the API open platform.",
    "Introduction_2":"This document is mainly aimed at platform developers and describes the relevant technical content of the express service technology docking platform. If you have any questions about the content of the document, you can contact the platform operation to answer the question.",
    date:"date",
    sdkVersion:"version number",
    updata:"Updates",
    updataInfo:"It provides a common interface standard to call an open platform, supporting the completion of the interface signature",
    "语言":"Language",
    最新版本:"Latest version",
    项目示例:"Project example",
    开发环境:"Development environment",
    "支持JAVA版本":"Support JAVA version: 1.8+",
    "支持PHP":"Support PHP7.0 and above",
    签名相关类:"Signature related classes",
    公用类:"Public class",
    异常相关类:"Exception related class",
    Http通信相关类:"Http communication related classes",
    开放平台api通用接口:"Open platform api general interface",
    执行器接口:"Actuator interface",
    "sdk_5_txt":`<p>1. The SDK compression toolkit is provided by the open platform. </p>
    <p>2. Unzip the "jt-openapi-sdk.zip" provided by the open platform and copy it to the project folder. </p>
    <p>3. Click File -> Project Structure (shortcut key Ctrl + Alt + Shift + s), click "Modules on the left side of the Project Structure interface.</p>
    <p>4. In the "Dependencies" tab interface, click the "+" sign on the right, select the first option "JARs or directories...", select the corresponding jar package, click "OK", the jar package is added successfully . </p>
    <p>5. The SDK calling method of the specific interface can be downloaded for reference. </p>`,
    sdk_6_txt:"SDK uses slf4j-api package for log output by default; SDK uses fastjson for json data conversion by default; SDK uses httpclient for http data transmission by default.",
    sdk_7_txt:`<p>JtExpressApi is the J&T open platform api general executor, which provides a series of interactive methods for developers who use the J&T open platform. </p>
    <p>Users can refer to the following code to create a new JtExpressApi. After the initialization is completed, it is recommended to use a singleton to avoid repeated creation:</p>`,
    sdk_8_txt:`<p>If you use the springboot framework to call API open platform-SDK related interfaces, it is recommended to put JtExpressApi in the spring container for management,</p>
    <p>Users can refer to the following code to create a new configuration class:</p>`,


  },
  controlPage:{
    "审核状态":"Review status",
    请输入酋长国: "Please enter city",
    请输入区域: "Please enter district",
    公司详细地址: "Company address",
    请输入社会信用代码: "Please enter license number",
    请上传营业执照: "Please upload image of business license",
    请输入法人身份证: "Please enter ID number of corporation",
    身份证详细地址: "ID address"
  },
  message: {},
  apiDoc: {
    极兔API简介: "Introduction to J&T API",
    订单服务: "Order service",
    创建订单: "Create Order",
    查询订单: "checking order",
    取消订单: "cancel order",
    订单状态回传: "Order status return",
    运费时效查询: "check freight e deadline",
    散客寄件: "Individual shipment",
    物流轨迹: "Logistics trajectory",
    物流轨迹查询: "Logistics track query",
    物流轨迹订阅: "Logistics track subscription",
    物流轨迹回传: "Logistics trajectory return",
    API简介: "API introduction",
    IntroductionContent: "In order to better serve our customers, Gitu Open Platform provides a standardized and unified access API to directly realize data interaction between customers and the platform and improve the convenience of both parties. This platform will give a detailed description of the access process and steps to facilitate customers to access the API platform more quickly and accurately.",
    "对接流程": "Docking process",
    process_1: "1. Registered users, register to be a member of Jitu Open Platform",
    process_2: "2. Apply to become a developer, improve developer information, and become an ordinary developer of the extremely rabbit open platform.",
    process_3: "3. Enterprise certification, complete enterprise information, obtain all interface permissions, and use order services, electronic face-to-face services, etc.",
    process_4: "4. Joint debugging and testing, debugging test environment interface services, and communicating with specific interface service personnel to solve problems.",
    process_5: "5. Release and go online, after the joint debugging test is passed, contact the specific interface service personnel to confirm the online details.",
    签名方式:"Signature method",
    method_1:"1. Use the http protocol form submission method for information interaction, the character encoding is unified by UTF-8 by default, and the data format: application/x-www-form-urlencoded;",
    method_2:"2. apiAccount and privateKey are provided by the platform; digest=base64(md5 (Json+privateKey of business parameters)), note: first md5 gets the byte array, and then base64 encryption;",
    method_3:`3. For example: base64(MD5({"age":18,"gender":"male","name":"zhangsan"}123456)) If the signature is wrong, you can encode the URL and send the request.`,
    method_4:"4. Field type convention: development should be carried out in strict accordance with the parameter format and size given in the field table.",
    method_5:"5. Field resolution conventions: the required fields in the parameter fields are required to be passed in every time the interface is called;",
    method_6:"6. For part of the interface sample code and SDK, please refer to the sample code and SDK documentation.",
    在线文档: "Online documentation",
    测试工具: "test tools",
    失败: "fail",
    Headers签名失败: "headers signature verification failed",
    内部调用异常: "Internal call exception",
    apiAccount为空: "apiAccount is empty!",
    digest为空: "digest is empty!",
    timestamp为空: "timestamp is empty!",
    系统错误: "System error",
    非法参数: "Illegal parameters",
    '获取电子面单': 'Obtain electronic waybill',
    '其他服务': 'other service',
    '重量推送': 'weight push',
    '重量订阅': 'weight subscription',
  },
  onlineDoc: {
    comCostAndTime: "Check the estimated shipping cost and time limit before placing an order",
    digestnew: "1.MD5 signature: Base64(MD5(customer number + ciphertext +privateKey), in which the ciphertext is MD5(plaintext password +jadada236t2) in uppercase; 2.SHA256 signature: Sha256(customer number + ciphertext +privateKey), in which the ciphertext is: Sha256(plaintext password)",
    "目的地邮编": "zip code destination",
    "始发地邮编": "origin zip code",
    "产品类型编码": "Postal type: including standard(express), express(express), EZ(ordinary express), CRD(regular express)",
    "重量（正数），单位kg，范围0.01-30，为空默认0.02": "weight (positive number)，Unit kg，Range 0.01-30，Empty default 0.02",
    "物品价值": "item value",
    "物品类型编码": "Item type (corresponding to the item type of the order master table):<p>bm000001 file</p><p>bm000002 digital products</p><p>bm000003 daily necessities</p><p>bm000004 food</p><p>bm000005 clothing</p><p>bm000006 other</p><p>bm000007 fresh food</p><p>bm000008 Fragile</p><p>bm000009 liquid</p>",
    "服务方式编码": "service method:<p>02 store delivery; ； </p><p>01 door-to-door pick-up</p>",
    "结算方式(1:寄件现结,2寄付月结,3:到付现结)": "settlement mode(1:CC settlement, 2CC monthly settlement, 3CC cash)",
    "报价类型, 0: 普通报价， 1：同城报价，2：同省报价": "Quote type, 0: common quote, 1: same city quote, 2: same province quote",
    "运费": "freight",
    "保险费+风险费": "ADV+GRIS",
    "保险费+风险费+运单运费": "ADV+GRIS+shipping weight",
    "时效/天": "deadline / day",
    地址: "Address: Use the URL provided by the access party",
    请求方法: "Request method:",
    数据类型: "type of data:",
    响应类型: "Response type:",
    接口说明: "Interface Description",
    接口信息: "Interface information",
    参数描述: "Parameter Description",
    Headers: "Headers",
    请求参数: "Request parameter",
    业务参数: "Business parameters",
    sender类型说明: "sender type description",
    receiver类型说明: "Receiver type description",
    items类型说明: "Item type description",
    customsInfo类型说明: "customsInfo type description",
    details类型说明: "details type description",
    报文描述: "Message description",
    响应参数: "Response parameters",
    data类型说明: "Data type description",
    请求示例: "Request example",
    返回示例: "Return example",
    错误代码: "Error code",
    错误编码: "error code",
    错误描述: "wrong description",
    测试地址: "Test address:",
    正式地址: "Official address:",
    测试apiAccount: "Test apiAccount:",
    测试privateKey: "Test privateKey:",
    属性名: "Attribute name",
    属性类型: "Attribute type",
    是否必填: "Is it required",
    示例: "Example",
    描述: 'describe',
    OrderDescription_1: "Customers who have signed a contract with the platform can create/modify orders through this interface. The current order creation interface supports order modification, that is, if the customer order number (txlogisticId) already exists and the corresponding order has not been collected, directly modify the existing order. If the recipient address changes, get the latest three-segment code/big end return;",
    OrderDescription_2: "Query the order created by the new order interface",
    OrderDescription_3: "Cancel orders generated through the new order interface",
    OrderDescription_4: "After the access party has provided the logistics status to return relevant information and completed the order placement operation, when the order-related status changes, the system will actively push the logistics information according to the push account configured by the access party.",
    OrderDescription_5: `Non-office contract customers can create individual customer orders through this interface. At present, the individual customer shipping interface supports order modification, that is, if the customer order number (txlogisticId) already exists and the corresponding order has not been collected, the existing order will be directly modified. You can upload the sender's information through the "real-name information upload" interface;`,
    "通过单号查询快件的轨迹信息": "Query the track information of the shipment through the tracking number",
    trackDescription_1: "Query the track information of the shipment through the tracking number",
    trackDescription_2: `Subscribe to Polar Rabbit to push the waybill number of the logistics track <br/> <strong>Note: Need to provide the URL of the return logistics track</strong> `,
    trackDescription_3: "After the access party has provided the delivery track push related information and completed the order placement operation, when the order-related waybill track changes, the system will actively push the logistics information according to the push account configured by the access party.",
    // 表单描述翻译
    接入方在平台的api账户标识: "The api account ID of the access party on the platform",
    签名字符串: "Signature string",
    "时间戳，毫秒": "Timestamp, milliseconds",
    业务参数模块内json格式的string类型: "The string type in json format in the business parameter module",
    "客户编码（联系出货网点提供）": "Customer code (provided by contacting the shipping outlet)",
    sign: "Signature, Base64 (Md5 (customer number + cipher text + privateKey)), where the cipher text: MD5 (plain text password + jadada236t2) followed by uppercase",
    合作网点: "Cooperation outlets",
    "客户订单号（传客户自己系统的订单号）": "Customer order number",
    ExpressType: `Express type: only supports "standard, express`,
    ExpressType1: `Express type: only support "standard (express), express (express), EZ (ordinary express), CRD (ordinary express)`,
    OrderType: "Order type (customer number is monthly settlement) 1. Individual customers; 2. Monthly settlement;",
    服务类型: "Type of service: 02 store delivery; 01 door-to-door pickup; 10 Drop_Off",
    "服务类型create": "Service type: 02 store delivery; 01 door-to-door pickup (when the store sends, the pickup address field is mandatory); 10 Drop_Off",
    "派送类型": "Delivery type: 03 home delivery",
    paymentMethod: `Payment method: PP_PM ("Send Payment Monthly"), CC_CASH ("Pay Cash Settlement");`,
    寄件信息对象: "Shipment information object",
    收件信息对象: "Receiving information object",
    取件信息对象: "Pickup Information Object",
    LC_pick_up_start_time: "Logistics company pick-up start time yyyy-MM-dd HH:mm:ss",
    CLC_door_to_door_end_time: "Customer logistics company's door-to-door pick-up end time yyyy-MM-dd HH:mm:ss",
    itemtType: "Item type (corresponding to the item type of the order master list): <p>bm000001 file</p> <p>bm000002 digital products</p> <p>bm000003 daily necessities</p> <p>bm000004 food</p> <p>bm000005 Apparel</p> <p>bm000006 Others</p> <p>bm000007 Fresh food</p> <p>bm000008 Fragile goods</p><p>bm000009 Liquid</p>",
    Length: "Length, cm",
    Width: "Width, cm",
    Height: "Height, cm",
    volume: "volume",
    Weight: "Weight, unit kg, range 0.01-30",
    "包裹总件数": "Total number of packages",
    "包裹总票数(必须为1)": "Total number of tickets for the package (must be 1)",
    "包裹总票数": "Total number of tickets for the package",
    "代收货款金额 (数值型)": "Amount of payment (numeric)",
    collectionPayment: "The currency of the collection payment (default local currency, such as: BRL)",
    offerFee: "Insured amount (numerical type), unit: BRL",
    "备注": "Remark",
    "商品信息列表": "Product information list",
    "子订单信息": "Sub-order information",
    "客户信息": "Customer Information",
    "寄件人姓名": "Sender name",
    "寄件公司": "Shipping company",
    "寄件邮编": "Shipping zip code",
    "寄件邮编（固定8位长度）": "Sending zip code (fixed 8-digit length)",
    "寄件邮箱": "Sending mailbox",
    "taxNumber": "Shipping taxNumber/CPF",
    "taxNumberNew": "Individual tax ID number (required if there is no sub-slip, if there is a sub-slip, the personal tax ID of the sub-slip is required, and the main form is optional, limited to 14 characters)",
    "寄件地区": "寄件地区",
    "invoceNumber": "Shipping invoceNumber",
    "invoceNumberNew": "Invoice number (required if there is no sub-order information)",
    "invoiceSerialNumber": "Invoice serial number (required if there is no sub-order information)",
    "invoicemoney": "Invoice amount (numeric), unit: BRL (required if there is no sub-order information)",
    "taxCode": "Invoice tax number (required if there is no sub-order information)",
    "invoiceAccessKey": "Invoice key (required if there is no sub-order information)",
    "invoiceIssueDate": "Invoice Issue Date",
    "packingNumber": "Enter packing list number",
    "documentNumber": "File No",
    "documentSeries": "file series",
    "documentKey": "file key",
    "documentCteKey": "tax file key",
    "cteKey": "CTe key or NFSe key",
    "invoiceType": "Type field(NFe CTe NFSe)",
    "docType": "0: NFE, 20: DCe. Default to NFE if not specified. If DCe is provided, validate the relevant identification information:<br/>0: NFE:<br/>(invoiceNumber, invoiceSerialNumber, invoiceMoney, invoiceAccessKey, taxCode are mandatory)<br/>20: DCe:<br/>(invoiceAccessKey, invoiceMoney, invoiceIssueDate are mandatory)",
    "orderInformation类型说明(数组)": "orderInformation type description (array)",
    "发票号码": "Invoice number",
    "发票序列号": "Invoice serial number",
    "发票金额(数值型)，单位：BRL": "Invoice amount (numeric), unit: BRL",
    "发票税号": "Invoice tax number",
    "发票密钥": "Invoice key",
    "寄件州": "Shipping State",
    "寄件市": "Shipping City",
    "寄件区": "Shipping area",
    "寄件街道号": "Shipping street number",
    "寄件详细地址": "Shipping details",
    "寄件人IE号": "Sender's IE number",
    "taxNumber2": "Individual tax ID number (required if there is no sub-slip, mandatory if there is a sub-slip, and optional for the main form)",
    "收件州": "recipient state",
    "收件市": "receiving city",
    "收件区": "receiving area",
    "收件街道号": "Receipt street number",
    "收件详细地址": "Delivery address",
    "收件人IE号": "Recipient's IE number",
    "translate类型说明": "translate type description",
    "取件人姓名": "Pickup name",
    "取件公司": "Pickup company",
    "取件邮编": "Pickup zip code (fixed 8-digit length)",
    "取件邮箱": "Pickup Email",
    "个人税号（限制14位字符）": "Personal Tax ID (limited to 14 characters)",
    "取件人手机（手机和电话二选一必填）": "Pickup person's mobile phone (either mobile phone or phone is required)",
    "取件人电话（手机和电话二选一必填）": "Pickup person's phone number",
    "取件州": "Pickup State",
    "取件市": "Pickup City",
    "取件区": "Pickup area",
    "取件街道": "Pickup Street",
    "取件街道号": "Pickup Street Number",
    "取件详细地址": "Pickup details",
    "取件区号": "Pickup area code",
    "取件人IE号": "IE number of the recipient",
    "商品NCM": "Commodity NCM",
    "NCM编码": "NCM description",
    "返回订单信息": "Back to order information",
    "orderList类型说明（数组）": "orderList type description (array)",
    SendingMobilePhone: "Sending mobile phone (required to choose one of mobile phone and phone)）",
    SendingPhoneNumber: "Sending phone number (required to choose one of mobile phone and phone)",
    ThreeCharacterSending: "Three-character country code of sending country (eg UAE=UAE, China=CHN, Indonesia=IDN)",
    "寄件酋长国": "Sending Emirate",
    "寄件区域": "Shipping area",
    "寄件街道": "Sending street",
    ShippingDetailedAddress: "Shipping detailed address (Emirate + area + street + detailed address)",
    "寄件区号": "Shipping area code",
    "收件人姓名": "The recipient's name",
    "收件公司": "receiver",
    "收件邮编": "Receiving postal code",
    "收件邮编（固定8位长度）": "Receiving zip code (fixed 8-digit length)",
    "收件邮箱": "Receiving mailbox",
    ReceivingMobilephone: "Receiving mobile phone (required to choose one of mobile phone and phone)",
    ReceivingPhoneNumber: "Receiving phone number (required to choose one of mobile phone and phone)",
    ThreeCharacterRecipient: "Three-character code of recipient country (eg UAE=UAE, China=CHN, Indonesia=IDN)",
    "收件酋长国": "Receiving Emirate",
    "收件区域": "Receiving area",
    "收件街道": "Receiving street",
    ReceivingDetailedAddress: "Receiving detailed address (Emirate + area + street + detailed address)",
    "收件区号": "Receiving area code",
    物品类型: "Item type: <p>bm000001 file</p> <p>bm000002 digital product</p> <p>bm000003 daily necessities</p> <p>bm000004 food</p> <p>bm000005 clothing</p> <p>bm000006 Others</p> <p>bm000007 Fresh products</p> <p>bm000008 Fragile products</p><p>bm000009 Liquid</p>",
    "物品名称": "Item Name",
    "物品中文名称": "Chinese name of the item",
    "物品英文名称": "English name of the item",
    cases: "Number of cases, ≥ 1",
    "申报价值(数值型)": "Declared value (numerical type)",
    priceCurrency: "Declare the payment currency (default domestic currency, such as: BRL)",
    "物品描述": "item description",
    "商品URL": "Product URL",
    "货物数量 跨境件报关需要填写": "The quantity of goods needs to be filled in for cross-border customs declaration",
    货物单位: "Cargo unit, such as: unit, Taiwan, this, cross-border cargo declaration needs to be filled in",
    原产地国别: "Country of origin, cross-border customs declaration needs to be filled in",
    货物产品国检备案编号: "National inspection record number of goods and products, cross-border customs declaration needs to be filled in",
    商品海关备案号: "Commodity customs record number",
    商品行邮税号: "Commodity postal tax number is required for cross-border customs declaration",
    海关编码: "Customs code is required for cross-border customs declaration",
    商品编号: "Commodity No. Cross-border customs declaration needs to be filled in",
    货物品牌: "Cargo brand cross-border customs declaration needs to be filled in",
    货物规格型号: "Cargo specifications and models, cross-border cargo declarations need to be filled in",
    生产厂家: "Manufacturers need to fill in cross-border customs declaration",
    托寄物声明价值: "The declared value of the consignment is required for cross-border customs declaration",
    托寄物声明价值币别: "Consignment declared value currency, cross-border customs declaration needs to be filled in",
    客户支付的运费: "The freight paid by the customer is required for cross-border customs declaration",
    "返回码，见附录": "Return code, see appendix",
    "业务数据": "Business data",
    "集包地": "Collection land",
    "返回客户订单号": "Return customer order number",
    订单创建时间: "Order creation time yyyy-MM-dd HH:mm:ss",
    "三段码online": "Three-segment code (get the three-segment code first to return to the three-segment code, if there is no three-segment code, return to the big pen)",
    "参考总运费": "Refer to the total freight (numerical type)",
    "查询命令": "Query command 1. Query by customer order number 2. Query by waybill number (check order status with waybill number) 3. Query by time period of order (check order) (query by time period returns unlimited number) 4. Order serial number",
    "查询命令：（枚举）": "Query Command: If not specified or left blank: By default, use billCodes to perform the tracking search; <p>0: billCodes (query based on waybill numbers)</p><p> 1: invoiceAccessKey (query using the invoice access key) </p><p>2: customerOrderNumber (query using the customer order number)</p>",
    "运单号多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单": "Waybill Numbers Multiple waybill numbers should be separated by an English comma, and currently, the system allows for a maximum of 30 waybills to be queried in a single request.",
    "发票秘钥多个发票秘钥以英文逗号隔开,目前先支持一次性最多查询30票运单": "Invoice Access Key Multiple key should be separated by an English comma, and currently, the system allows for a maximum of 30 waybills to be queried in a single request.",
    "客户订单编号多个运以英文逗号隔开,目前先支持一次性最多查询30票运单": "Customer Order Number Multiple key should be separated by an English comma, and currently, the system allows for a maximum of 30 waybills to be queried in a single request.",
    "发票秘钥": "Invoice Access Key",
    command: "ccommand=1 customer order number query; command=2 waybill number temporarily; command=4 order number (internal company) supports 200; Command=1, 2 or 3 is required",
    startDate: "Start time (24 hour system: yyyy-MM-dd HH:mm:ss) (Required when command is 3) (Required when the customer places an order) Command = 3",
    endDate: "End time (24-hour system: yyyy-MM-dd HH:mm:ss) (Required when command is 3), the time range is up to 7 days and command = 3 is required",
    status: "Status (the order status is taken from the status table below, filtered data is used, all by default): canceled 104; picked up 103; dispatched salesperson 102; dispatched outlets 101; not dispatched 100",
    "command = 3 时必填": "Required when command = 3",
    系统订单号: "System order number",
    "客户订单号-客户自己系统的订单号": "Customer order number The order number of the customer's own system",
    "快件类型": `Express type: only supports "standard, express`,
    订单状态: "Order status: 104 has been cancelled; 103 has been picked up; 102 salesperson has been dispatched; 101 outlets have been dispatched; 100 have not been dispatched",
    订单类型: "Order type: 01 individual customers 02 month settlement",
    三段码: "Three-segment code",
    "客户编码（订单类型传2时，必填）": "Customer code (required when the order type is passed 2)",
    "客户编码必填描述": "<p>Customer Code</p>When requesting a tracking query using the customerOrderNumber, the customer code must be provided.",
    "订单类型  1（散客），2（协议客户）": "Order type 1 (individual customers), 2 (contract customers)",
    "取消原因": "Reason for Cancellation",
    "运单号": "Waybill number",
    "客户订单号": "customer order no",
    operateType: `In the event, the customer fills in "Add" to add an order; if the customer submits "Update", then an order is updated.<p>1 Adding</p><p>2 Modifying</p>`,
    客户订单编号: "Customer order number",
    极兔运单编号: "Jitu Waybill Number",
    "网点名称（“已调派业务员”回传）": `Name of outlets (returned by "salesman assigned")`,
    "业务员名称（“已调派业务员”回传）": `Salesperson's name (returned by "deployed salesperson")`,
    "业务员联系方式（“已调派业务员”回传）": `Contact information of salesperson (returned by “deployed salesperson”)`,
    极兔订单编号: "Jitu order number",
    "重量（“已揽收”“已取件”时回传）": `Weight (returned when "collected" and "collected")`,
    "订单取消原因（“已取消”时回传）": `Reason for order cancellation (returned when "cancelled")`,
    "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)": `Status ("salesman has been dispatched", "collected", "collected", "canceled")`,
    "时间": "time",
    承运商编码: "Carrier code",
    "业务员编码（联系出货网点提供，且采用网点编码签名）": "Salesman code (provided by contacting the shipping outlet, and signed by the outlet code)",
    "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写": "Signature, Base64 (Md5 (customer code/salesman code+ciphertext+privateKey)), where the ciphertext: MD5 (plaintext password/point code+jadada236t2) followed by capital",
    运单编号: "Waybill number",
    "快件类型：EZ(标准快递)": "Express type: EZ (standard express)",
    "订单类型  1、散客；": "Order type 1. Individual customers;",
    "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）": `Payment method CC_CASH ("Pay and cash settlement"); PP_CASH ("Pay and cash settlement")`,
    "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss": "The end time of the logistics company's pick-up yyyy-MM-dd HH:mm:ss",
    "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单": "Waybill number. Multiple waybill numbers are separated by English commas. Currently, it supports querying up to 30 waybills at one time.",
    运单轨迹详情: "Waybill track details",
    扫描时间: "Scan time",
    轨迹描述:  "Trajectory description",
    scanType: "Scan type <p>1, express mail collection</p> <p>2, in-stock scanning (disabled)</p> <p>3, outgoing scanning</p> <p>4, incoming scanning </p> <p>5. Outbound scanning</p> <p>10. Express delivery</p> <p>11. Problem scanning</p> <p>12、Return scanning</p>",
    scanCode: "scan type code： <p>express mail collection：10</p> <p>in-stock scanning (disabled):20</p> <p>outgoing scanning:50</p> <p>incoming scanning:92</p> <p>Outbound scanning:94</p>  <p>Express delivery:100</p> <p>Problem scanning:110</p> <p>Return scanning：172</p>",
    problemType: "<p>P71a Non-compliant packaging on collection</p><p>P13a Incomplete collection address</p><p>P13b Incorrect collection address</p><p>D13a Incomplete address</p><p>D13b Incorrect address</p><p>D16a Refusal of receipt by the customer (recipient)</p><p>D65a Inability to arrive at the given address</p><p>D65b Absence of recipient</p><p>D65n Absence of recipient in several delivery attempts</p><p>D66b Tax inspection</p><p>D66c Abnormal weather</p><p>R17a Devolution</p><p>R73b Failure to return to customer or PA.</p><p>83a Return to platform</p><p>S70a Theft or Assault</p><p>S41a Order lost during delivery</p><p>Z41d Lost internal product and damaged packaging</p><p>Z41e Lost internal product and packaging in good condition</p><p>Z27a Damaged packaging and internal product</p><p>Z27b Internal product damaged, packaging in good condition</p>",
    扫描网点名称: "Scan site name",
    扫描网点ID: "Scan site ID",
    业务员姓名: "Salesman's name",
    业务员联系方式: "Salesman contact information",
    扫描网点联系方式: "Scan the contact information of outlets",
    扫描网点省份: "Scan the provinces of outlets",
    扫描网点城市: "Scan the city",
    "扫描网点区/县": "Scanning outlet district/county",
    "上一站(到件)或下一站名称(发件)": "Last stop (arrival) or next stop name (sent)",
    "下一站省份（发件扫描类型时提供）": "Next stop province (provided when sending scan type",
    "下一站城市（发件扫描类型时提供）": "Next stop city (provided when sending scan type)",
    "下一站区/县（发件扫描类型时提供）": "Next stop district/county (provided when sending scan type)",
    "经度": "Longitude",
    "纬度": "Latitude",
    "签收人": "Recipient",
    "签收类型名称": "Signature Type Name<br />1.Consignee（Personal Receipt）<br />2.Collection point/store（Self-Pickup）<br />3.Others（Third-Party Collection）",
    "电子签名图片": "Electronic Signature Image",
    "签收图片": "Receipt Image",
    快递轨迹详情: "Courier track details",
    "订阅节点": "Subscription node: 1&2&3&4&5&10&11 <p>1, express mail collection</p> <p>2, warehouse scanning (disabled)</p> <p>3, mail scanning</p> <p>4, to Scanning</p> <p>5. Scanning out of warehouse</p> <p>10. Signing for express mail</p> <p>11. Scanning for problems</p>",
    数组: "Array",
    "明文密码:H5CD3zE6": "Clear text password: H5CD3zE6",
    'getPrintDesc': '可通过运单号获取电子面单的模板信息。',
    '客户编码': '客户编码',
    'noodleSpecification': '面单规格 1：76*130mm',
    'base64文件流': 'base64文件流',
    printSize: `Print label size:<br/>0: One-sided sheet<br/>1: Two-page single<br/>2: A4`,
    "base64": "Base64 decodes the byte array of the file",
    OrderDescription_6: "Users can obtain template information of electronic sheet through the interface",
    'weightApi': 'Once the integration party has provided relevant information for courier weight notifications and completed the interface integration, the system will proactively push weight, length, and width information based on the configured notification account when there is a change in the weight of the order.',
    '长，cm': '长，cm',
    '宽，cm': '宽，cm',
    '高，cm': '高，cm',
    '计费重量': 'Chargeable weight.',
    'weightSubscribe': 'Subscribe to J&T for sending the weight, length, and width information of waybill numbers. Batch processing supports a maximum of 30 waybill numbers.', // <br/><p style="font-weight: bold">注意事项：需提供回传重量和长宽高的URL</p>
    '经度New': 'Longitude. It is recommended to retain up to 6 decimal places',
    '纬度New': 'Latitude: It is recommended to retain up to 6 decimal places',
  },
  apiTestDoc: {
    接口说明: "Interface Description",
    Headers: "Headers",
    Body: "Body",
    Response: "Response",
    错误代码: "Error code",
    错误编码: "error code",
    错误描述: "wrong description",
    请求头Headers参数: "Request Headers parameters",
    不能为空: "can not be empty",
    参数: "parameter",
    业务参数签名失败: "Business parameter signature verification failed",
    修改订单失败: "Order modification failed",
    区域不合法: "Illegal region",
    城市不合法: "Illegal city",
    省份不合法: "Illegal province",
    查不到数据: "Data not found",
    下单失败: "der placement failed",
    发件人信息不全: "Incomplete sender information",
    "订单重复,无需重复下单！": "Duplicate order, don't place the order repeatedly!",
    收件人信息不全: "Incomplete recipient information",
    电话号码不能为空: "Phone number cannot be empty",
    地址信息不全: "Incomplete address information",
    "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法": "Please check whether the order type, service type, delivery type, item type, shipment type and settlement method are legal",
    "请检查服务类型是否合法值为 01或 02": "Please check if the service type is legal with the value of 01 or 02",
    上门服务时间信息不全: "Incomplete service time information",
    重量信息不合法: "The weight information is not legal",
    物品信息不全: "Incomplete item information",
    物品名称不全: "Incomplete item name",
    物品类型不全: "Incomplete item type",
    "客户订单号已存在,无法下单！": "Customer order number already exists, cannot place an order!",
    姓名信息非法: "Illegal name information",
    公司信息过长: "Company information is too long",
    联系信息过长: "Contact information is too long",
    邮编或邮箱信息非法: "Postcode or email address is illegal",
    价格信息非法: "Price information is illegal",
    "备注、描述、链接信息非法": "Comments, descriptions, links are illegal",
    地址信息过长: "Too much address information",
    街道信息过长: "Street information is too long",
    包裹总件数无效: "The total number of parcels is invalid",
    暂未开通代收货款业务: "Not yet open COD business",
    "支付方式不匹配,PP_CASH,CC_CASH,PP_MM": "The payment method does not match,PP_CASH,CC_CASH,PP_MM",
    "已取件状态不可修改": "Picked up status can not be modified",
    "已取消状态不可修改": "Cancelled status can not be modified",
    "更新订单失败，请稍后重试！": "Update order failed, please try again later!",
    "始发地信息不全": "Incomplete information of origin",
    "收货地信息不全": "Incomplete information of receiving place",
    "发票信息不全": "Incomplete invoice information",
    "发票信息不合法": "Invoice information is invalid",
    "寄件人个人税号信息非法": "The sender's personal tax number information is illegal",
    "请填写正确的快件类型": "Please fill in the correct shipment type",
    "订单数量不一致": "Order quantity is inconsistent",
    "请填写正确的派送类型": "Please fill in the correct delivery type",
    "请填写正确的寄件/收件酋长国和地区": "Please fill in the correct sending/receiving emirate and district",
    "操作类型不能为空": "Operation type cannot be empty",
    "COD和COD的币种必须为空或同时必填": "The COD and the type of currency of COD must be empty or required at the same time",
    "COD(货到付款)不能大于30000": "The COD(collection on delivery) cannot be greater than 30000",
    "客户订单号重复，请稍后重试": "Duplicate customer order number，please try again in a minute",
    "请输入正确的税号": "Please enter the correct taxNumber",
    "请输入正确的IE号": "Please enter the correct ieNumber",
    "非法发件人邮政编码/非法收件人邮政编码/非法取件人邮政编码": "Illegal sender postcode/Illegal receiver postcode/Illegal translate postcode",
    "找不到客户": "Customer not found",
    "客户代码不合法": "Customer code is illegal",
    "客户订单号不能为空或太长": "Customer order number cannot be empty or too long",
    "订单数量不同，无法修改订单": "The order quantity is different, the order cannot be modified",
    "时间范围非法": "Illegal time range",
    "页码非法": "Illegal page number",
    "超过数据限制": "Data limit exceeded",
    "客户订单号不能为空或过长": "Customer order number cannot be empty or too long",
    "取消原因不能为空": "Cancellation reason cannot be empty",
    运单号非法: "Illegal waybill number",
    运单号个数超过30: "The quantity of the waybill number exceeds 30",
    运单号个数超过1000: "The quantity of the waybill number exceeds 1000",
    物品数量非法: "Illegal item quantity",
    非法金额: "Illegal amount"
  },
  ...lang,
};

export default messages;
